<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton
          icon="fa-plus"
          v-on:click="onClickButton"
        />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <ComponentList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import ComponentList from '@/components/settings/stock-registers/component/ComponentList'
  import ActionButton from '@/components/button/ActionButton'

  export default {
    name: 'ComponentLists',
    components: {
      PageTitle,
      ActionButton,
      PageRowWrapper,
      ComponentList
    },

    methods: {
      onClickButton (e) {
        this.$router.push({ name: 'addcomponent' })
      }
    }
  }
</script>